<template>
   <div class="wdlModalBox" v-show="ModalShow">
       <div class="MaskModal"></div>
        <div :title="title" class="wdlModal" :style="TranStyle">
          <div class="ContentModal">
             <div v-if="CloseIcon" class="closeIcon iconfont icon-2guanbi" :class="{btnTopRight:BtnDefaultPosition=='TopRight'}" :style="CloseStyle" @click="closeLogin"></div>
             <!-- 内容 -->
             <slot></slot>
             <div class="confirmContent">
                <div class="iconConfirm">
                  <span class="iconfont icon-wenhao1 wenhaocc"></span>
                </div>
                <div class="tipText">{{ContentText}}</div>
             </div>
             <!-- 底部 -->
             <div class="confirmFooter">
               <div class="footerBox">
                   <div class="cancleBtn">
                     <div class="c_btn c_cancle" @click="CancelFn">{{CancelText}}</div>
                    </div>
                   <div class="confirmBtn">
                     <div class="c_btn c_sure" @click="OkFn">{{OkText}}</div>
                   </div>
               </div>
              
             </div>
          </div> 
      </div>
  </div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
         ModalShow: this.ConfirmModalOpen,
         title:"",
      }
    },
    watch: {
      ConfirmModalOpen: function(newval) {
        this.ModalShow = newval;
      }
    },
    props:{
      //是否需要关闭icon
      CloseIcon:{
        type:Boolean,
        default:false,
      },
      // 是否打开modal
      ConfirmModalOpen:{
        type:Boolean,
        default:false,
      },
      // 按钮的位置
      BtnDefaultPosition:{
        type:String,
        default:'TopRight',
      },
      //定义弹框的宽度
      ModalWidth:{
         type:String,
         default:'60%',
      },
      //定义弹框的高度
      ModalHeight:{
         type:String,
         default:'600',
      },
      //提示语
      ContentText:{
        type:String,
      },
      //取消按钮的文本
      CancelText:{
        type:String,
        default:'取消',
      },
      //确认按钮的文本
      OkText:{
        type:String,
        default:'确认',
      },
      //取消按钮的事件
      CancelFn:{
        
      },
      OkFn:{
        
      }

    },
    computed:{
      //样式转换
      TranStyle(){
        let $Width=this.ModalWidth;
        let $Height=this.ModalHeight;
        let $MarginLeft,$MarginTop;
        if($Width.includes('%')){
          $Width=$Width;
          $MarginLeft=(-($Width.replace('%','')/2))+'%';
        }else{
          $MarginLeft=(-($Width/2))+'px';
          $Width=$Width+'px'; 
        }
        if($Height.includes('%')){
          let cHight=document.body.clientHeight;
          $Height=(cHight*($Height.replace('%','')))/100;
          $MarginTop=(-($Height/2))+'px';
          $Height= $Height+'px';
        }else{
          $MarginTop=(-($Height/2))+'px';
          $Height=$Height+'px';
        }
    
        // 
       return  {width:$Width,marginLeft:$MarginLeft,height:$Height, marginTop:$MarginTop,}
      },
      CloseStyle(){
        let $Width=this.ModalWidth;
        let $Height=this.ModalHeight;
        let $MarginRight,$MarginTop;
        if($Width.includes('%')){
          $Width=$Width;
          $MarginRight=(-($Width.replace('%',''))/2)+'%';
        }else{
          $MarginRight=(-($Width/2))+'px';
          $Width=$Width+'px'; 
        }
        if($Height.includes('%')){
          let cHight=document.body.clientHeight;
          $Height=(cHight*($Height.replace('%','')))/100;
          $MarginTop=(-($Height/2))+'px';
          $Height= $Height+'px';
        }else{
          $MarginTop=(-($Height/2))+'px';
          $Height=$Height+'px';
        }
       return  {marginTop:$MarginTop,marginRight:$MarginRight}
      }
    },
    methods:{
       closeLogin(){
        this.ModalShow = false;
        this.$emit('ModalClose', false)
      },
      
    }
  }
</script>

<style lang="scss" scoped>
.wdlModalBox{
    color: #333;
    .MaskModal{
       position: fixed;
       top:0;
       right: 0;
       bottom: 0;
       left: 0;
       width: 100%;
       height: 100%;
       background: rgba($color: #000000, $alpha: 0.4);
       z-index: 90;
    }
    .wdlModal{
        padding: 0px 20px 10px 20px;
        border-radius: 0px;
        height: 70%;
        border-radius: 10px;
        position: fixed;
        background: #fff;
        z-index: 99;
        left: 50%;
        right: 0;
        /* bottom: 0; */
        top: 50%;
        margin-left: -160px;
        margin-top: -35%;
       
        .ContentModal{
          width: 100%;
          // height: 100%;
          position: relative;
          height: 100%;
          overflow-x: hidden;
           overflow-y:auto ;
          .closeIcon{
              position: fixed;
              top: 50%;
              // margin-top: 200px;
              right: 50%;
              cursor: pointer;
              z-index: 99999;
              font-size: 30px;
              color:#fff;
              margin-right:-15px;
            }
            .icon-2guanbi:before{
              display: block;
              margin-top:-40px;
              margin-right: -40px;
            }
          // .btnTopRight{
          //       top: -36px;
          //       right: -45px;
          //   }
        }
    }
    .ContentModal{
      position: relative;
    }
    .confirmContent{
      .iconConfirm{
        padding:20px 10px;
        .wenhaocc{
          font-size: 60px;
          color:#ffc236;
        }
       
      }
       .tipText{
          font-size: 22px;
      }
    }
    .confirmFooter{
      position: absolute;
      bottom:20px;
      width: 100%;
      left: 0;
      right: 0;
      .footerBox{
        display: flex;
        .cancleBtn{
          flex: 1;
        }
        .confirmBtn{
          flex: 1;
        }
        .c_btn{
          padding:10px 46px;
          background: #fff;
          display: inline-block;
          color:#000;
          border-radius: 4px;
          cursor: pointer;
          border:1px solid $lightColor;
          font-size: 16px;
        }
        .c_sure{
          color:#fff;
          background: $lightColor;
          border:1px solid $lightColor;
        }
      }
    }
}
</style>